/* ==========================================================================
   Press Cards – Parallax (cards only, non-stack mode)
   - La colonne éditoriale reste fixe; seules .pcard-exp bougent légèrement
   - Désactivé si: data-stack="true" OU prefers-reduced-motion
   - Optimisations: IntersectionObserver + rAF + pause quand onglet masqué
   ========================================================================== */
(function () {
  const root = document.querySelector('.press-cards-exp');
  if (!root) return;

  // Empilement actif ? On sort (le stack est 100% CSS)
  if (root.getAttribute('data-stack') === 'true') return;

  // Respect des préférences utilisateur
  const mReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const prefersReduce = mReduce.matches;
  const parallaxEnabled = root.getAttribute('data-parallax') === 'true';
  if (!parallaxEnabled || prefersReduce) return;

  // Force du parallax (0–0.2 recommandé)
  const strength = Math.max(
    0,
    Math.min(0.2, parseFloat(root.getAttribute('data-parallax-strength') || '0.08'))
  );

  const cards = Array.from(root.querySelectorAll('.pcard-exp'));
  if (!cards.length) return;

  // --------- State ----------
  const visible = new Set();
  let ticking = false;
  let paused = document.visibilityState === 'hidden';

  // Reset helper
  function resetTransform(el) {
    el.style.transform = '';
  }

  // --------- Observer (pré-observe ~15% avant) ----------
  const io = new IntersectionObserver(
    entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          visible.add(e.target);
        } else {
          resetTransform(e.target);
          visible.delete(e.target);
        }
      });
      requestTick();
    },
    { root: null, threshold: 0, rootMargin: '15% 0px' }
  );

  cards.forEach(c => io.observe(c));

  // --------- RAF loop ----------
  function requestTick() {
    if (ticking || paused) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function update() {
    ticking = false;
    if (paused || visible.size === 0) return;

    const vh = window.innerHeight || 1;
    visible.forEach(el => {
      const rect = el.getBoundingClientRect();
      // Position relative au centre de l’écran
      const center = rect.top + rect.height / 2;
      const delta = (center - vh / 2) / vh; // environ [-0.5, 0.5]
      // Clamp & conversion en px
      const t = Math.max(-0.75, Math.min(0.75, -delta)) * (strength * 100);
      el.style.transform = `translateY(${t.toFixed(2)}px)`;
    });
  }

  function onScroll() {
    requestTick();
  }

  function onResize() {
    requestTick();
  }

  // Pause / reprise suivant la visibilité de l’onglet
  function onVisibility() {
    paused = document.visibilityState === 'hidden';
    if (!paused) requestTick();
  }

  // Changement dynamique de prefers-reduced-motion
  function onReduceChange(e) {
    if (e.matches) {
      // L’utilisateur vient d’activer la réduction: on stoppe et on reset
      cleanup();
    } else {
      // Si parallax toujours autorisé côté data-attr, on relance une passe
      requestTick();
    }
  }

  // --------- Events ----------
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  document.addEventListener('visibilitychange', onVisibility);
  if (mReduce && typeof mReduce.addEventListener === 'function') {
    mReduce.addEventListener('change', onReduceChange);
  } else if (mReduce && typeof mReduce.addListener === 'function') {
    // Safari < 16
    mReduce.addListener(onReduceChange);
  }

  // Premier rendu
  requestTick();

  // --------- Cleanup (si besoin) ----------
  function cleanup() {
    // Retire les transforms
    cards.forEach(resetTransform);
    // Détache les events
    window.removeEventListener('scroll', onScroll, { passive: true });
    window.removeEventListener('resize', onResize, { passive: true });
    document.removeEventListener('visibilitychange', onVisibility);
    if (mReduce && typeof mReduce.removeEventListener === 'function') {
      mReduce.removeEventListener('change', onReduceChange);
    } else if (mReduce && typeof mReduce.removeListener === 'function') {
      mReduce.removeListener(onReduceChange);
    }
    // Stoppe l’observer
    io.disconnect();
  }

  // Optionnel: exposer un handle pour nettoyer si la section est retirée du DOM
  root.__pressCardsParallaxCleanup = cleanup;
})();
